import { Badge } from "@mantine/core";
import { useTranslation } from "react-i18next";
import { useBadgeVariant } from "@hooks/useBadgeVariant";

export function LatestBadge() {
  const { t } = useTranslation();
  return (
    <Badge size="xs" color="dark" variant={useBadgeVariant()}>
      {t("headsetReleases.latest")}
    </Badge>
  );
}
